import BannedCustomers from 'containers/Customers/List/BannedCustomers';
import Create from 'containers/Customers/Create';
import Edit from 'containers/Customers/Edit';
import Show from 'containers/Customers/Show';

export default { Create, Edit, Show, BannedCustomers };
